import { Capacitor } from '@capacitor/core'

// Two frames, not one: the first callback runs before a paint, the second once it is on screen.
function nextPaint(): Promise<void> {
  return new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
  })
}

/** Native only: the splash does not hide itself, and goes once the boot screen of index.html, its
 *  copy, is painted under it. The plugin comes in with `import()`, as the status bar's does.
 *  Never rejects, as `main.tsx` does not wait for it: a failure is logged. */
export async function handOverNativeSplash(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return
  try {
    await nextPaint()
    const { SplashScreen } = await import('@capacitor/splash-screen')
    await SplashScreen.hide()
  } catch (error) {
    console.error('handing over the native splash failed', error)
  }
}
